import { OOMenu } from "./oo-menu";

export class OOAliasUrl {
	guid: string;
	alias: string;
	venueKey: number;
	created: Date;
	lastAccessed: Date;
	menuKey: string;

	customMenu?: OOMenu;

	public constructor(init?: Partial<OOAliasUrl>) {
		Object.assign(this, init);
	}
}
